const axios = require("axios");
window._ = require('lodash');
window.axios = require('axios');
window.axios = window.axios.create({
    baseURL: "/",
    // withCredentials: false,
    // timeout: 1000,

    headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/x-www-form-urlencoded',
    }
});
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(function (config) {
    config.data = {
        ...config.data, // Preserve existing parameters
        csrf_token: window.csrf_token // Add your custom parameter
    };
    return config;
}, function (error) {
  if (error.response) {
    // Request made and server responded
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    // The request was made but no response was received
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
})